import { buildInFilter, buildODataQuery, mergeFilters } from "@sg-protect/core";
import { queryOptions } from "../../client.ts";

export function bulkOperationsQueryOptions() {
    const query = buildODataQuery({
        select: [
            "bulkId",
            "action",
            "status",
            "succeededCount",
            "failedCount",
            "errorMessage",
            "targetDisplayName",
            "source",
            "reviewId",
            "createdAt"
        ],
        filter: mergeFilters([
            buildInFilter("status", ["InProgress", "Failure", "PartialFailure"]),
            "isDismissed eq false"
        ]),
        orderby: { field: "createdAt", direction: "desc" },
        count: false
    });

    return queryOptions(
        "get",
        "/bff/odata/bulkOperations",
        { params: { query } },
        {
            refetchInterval: ({ state }) =>
                state.data?.value?.some(operation => operation.status === "inProgress") ? 5000 : 30000
        }
    );
}
